<script lang="ts">
	import { intersectionObserver } from '$lib/shared/lib/intersectionObserver';
	import type { Snippet } from 'svelte';

	interface Props {
		/** Vertical travel distance in px before settling. */
		y?: number;
		/** Stagger delay in ms. */
		delay?: number;
		class?: string;
		children?: Snippet;
	}

	let { y = 28, delay = 0, class: className = '', children }: Props = $props();

	let visible = $state(false);
</script>

<!-- Scroll-reveal wrapper. The transition is gated behind
     prefers-reduced-motion in CSS, so under reduced motion the content is
     simply visible with no transform. -->
<div
	use:intersectionObserver={{ once: true, threshold: 0.15, rootMargin: '0px 0px -8% 0px' }}
	onintersect={(e: CustomEvent<{ isIntersecting: boolean }>) => {
		if (e.detail.isIntersecting) visible = true;
	}}
	class="reveal {className}"
	class:is-visible={visible}
	style="--reveal-y: {y}px; --reveal-delay: {delay}ms;"
>
	{@render children?.()}
</div>

<style>
	@media (prefers-reduced-motion: no-preference) {
		.reveal {
			opacity: 0;
			transform: translateY(var(--reveal-y));
			transition:
				opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1) var(--reveal-delay),
				transform 0.7s cubic-bezier(0.16, 1, 0.3, 1) var(--reveal-delay);
			will-change: opacity, transform;
		}
		.reveal.is-visible {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* Safety net: with scripting disabled the IntersectionObserver never fires, so
	   keep content visible rather than shipping a blank section. */
	@media (scripting: none) {
		.reveal {
			opacity: 1;
			transform: none;
		}
	}
</style>
